import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { AgentProofsTitle } from '../../../../../components/AuthorAsideNew';
import { selectOfferAgent } from '../../../../../selectors';
import { getAgentType } from '../../../../../utils/getAgentType';
import { getProofMessage } from '../../../../../utils/getProofMessage';

export const AgentProofsTitleContainer: React.FC = () => {
  const agent = useSelector(selectOfferAgent, shallowEqual);

  const agentType = agent && getAgentType(agent);
  const message = agentType && getProofMessage(agentType);

  if (!agentType || !message) {
    return null;
  }

  return (
    <li>
      <AgentProofsTitle size="medium" title={message} />
    </li>
  );
};
